import "./Input.css";
export const Input = () => {
  return (
    <div>
      <input className="input" />
    </div>
  );
};
